module.exports = __webpack_public_path__ + "static/img/index1(1)_06.06ae9e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/images/index1(1)_06.png
// module id = 3116
// module chunks = 1